import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomerServiceNote } from '@uzurv/clara';
import { Observable } from 'rxjs';
import { Store, State } from '@ngrx/store';
import { TripDetailState } from '../../../store/trip-detail/trip-detail.reducer';
import { AddFareReviewNote } from '../../../store/trip-detail/trip-detail.actions';

export interface TripNotesDialogData {
  fareReviewNotes: Observable<Array<CustomerServiceNote>>;
}

@Component({
  selector: 'app-trip-notes-dialog',
  templateUrl: './trip-notes-dialog.component.html',
  styleUrls: ['./trip-notes-dialog.component.scss']
})
export class TripNotesDialogComponent {
  customerServiceNotes = new Array<CustomerServiceNote>();
  constructor(
    private dialogRef: MatDialogRef<TripNotesDialogComponent>,
    private store$: Store<State<TripDetailState>>,
    @Inject(MAT_DIALOG_DATA) public data: TripNotesDialogData
  ) {}

  handleCloseDialog() {
    this.dialogRef.close(false);
  }
  handleCreateNote(note: CustomerServiceNote) {
    this.store$.dispatch(AddFareReviewNote({ fareReviewNoteText: note.text }));
  }
}
